import { render } from "./PhoneNumber.vue?vue&type=template&id=0f9dc8c0&scoped=true"
import script from "./PhoneNumber.vue?vue&type=script&lang=js"
export * from "./PhoneNumber.vue?vue&type=script&lang=js"

import "./PhoneNumber.vue?vue&type=style&index=0&id=0f9dc8c0&lang=scss&scoped=true"
import "./PhoneNumber.vue?vue&type=style&index=1&id=0f9dc8c0&lang=scss"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9dc8c0"]])

export default __exports__